import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Soal from '../views/Soal.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/konfirmasi',
    name: 'Konfirmasi',
    component: () => import(/* webpackChunkName: "konfirmasi" */ '../views/Konfirmasi.vue')
  },
  {
    path: '/soal',
    name: 'Soal',
    component: Soal
  },
  {
    path: '/nilai',
    name: 'Nilai',
    component: () => import(/* webpackChunkName: "nilai" */ '../views/Nilai.vue')
  },
  {
    path: '/reset12345',
    name: 'Reset',
    component: () => import(/* webpackChunkName: "reset" */ '../views/Reset.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
